export default [
  {
    name: 'raio-x-empresa',
    path: '/raioxEmpresa',
    component: () => import('@/app/raio-x-empresa/RaioXEmpresaView.vue'),
    meta: {
      resource: 'login',
      action: '',
      requiredAuth: false,
      layout: 'full',
      pageTitle: 'Raio-X Fiscal',
    },
  },
]
